import { KITCHEN_LOCATIONS } from './restaurants.constants';
import { LabelWeight } from '../components';

export const timersCycleHistoryColumns = [
  {
    label: '',
    value: 'frames',
  },
  {
    label: 'Material',
    value: 'material',
    mobile: true,
  },
  {
    label: 'Pan Id',
    value: 'panId',
    mobile: true,
  },
  {
    Component: <LabelWeight label="Start Quantity" />,
    value: 'startQuantity',
    mobile: true,
  },
  {
    Component: <LabelWeight label="Corrected Quantity" />,
    value: 'correctedStartQuantity',
  },
  {
    Component: <LabelWeight label="Available Quantity" />,
    value: 'availableQuantity',
  },
  {
    label: 'Time In HZ',
    value: 'timeInHZ',
  },
  {
    label: 'Hot Holding Start Position',
    value: 'hotHoldingPosition',
  },
  {
    label: 'Hot Holding End Position',
    value: 'endHotHoldingPosition',
  },
  {
    label: 'Pan In Hot Holding Placed',
    value: 'panInHotHoldingPlaced',
  },
  {
    label: 'Pan From Hot Holding Removed',
    value: 'panFromHotHoldingRemoved',
  },
  {
    label: 'Chicken Batch Id',
    value: 'chickenBatchId',
  },
];

export const timersAnalyticClassNames = [
  { label: 'Breading', value: 'BreadingTimerCycleHistory', location: KITCHEN_LOCATIONS.BREADING },
  { label: 'Fryer', value: 'FryerTimerCycleHistory', location: KITCHEN_LOCATIONS.FRYER },
  { label: 'Conveyor', value: 'ConveyorTimerCycleHistory', location: KITCHEN_LOCATIONS.CONVEYOR },
  { label: 'Hot Holding', value: 'TimerCycleHistory', location: KITCHEN_LOCATIONS.HOT_HOLDING },
  {
    label: 'Merco Hot Holding',
    value: 'MercoTimerCycleHistory',
    location: KITCHEN_LOCATIONS.MERCO_HOT_HOLDING,
  },
  { label: 'PRS', value: 'PrsTimerCycleHistory', location: KITCHEN_LOCATIONS.PRS },
  {
    label: 'Entree Chutes',
    value: 'EntreeChutesTimerCycleHistory',
    location: KITCHEN_LOCATIONS.ENTREE_CHUTES,
  },
  {
    label: 'Scheduled Production',
    value: 'CateringTimerCycleHistory',
    location: KITCHEN_LOCATIONS.SCHEDULED_PRODUCTION,
  },
];

export const timersColors = [
  '#1999F4',
  '#17B61F',
  '#9747FF',
  '#D872DD',
  '#F4D548',
  '#FF7D00',
  '#DD0031',
  '#22aa99',
  '#aaaa11',
  '#6633cc',
  '#e67300',
  '#8b0707',
  '#651067',
  '#329262',
  '#5574a6',
  '#3b3eac',
  '#b77322',
  '#16d620',
  '#b91383',
  '#f4359e',
  '#9c5935',
  '#a9c413',
  '#2a778d',
  '#668d1c',
  '#bea413',
  '#0c5922',
  '#743411',
];

export const TCHCorrectness = {
  Valid: 'VALID',
  PossiblyIncorrect: 'POSSIBLY_INCORRECT',
  Incorrect: 'INCORRECT',
};
